import { render, staticRenderFns } from "./PersonDepartureCardV2.vue?vue&type=template&id=6753c34e&scoped=true"
import script from "./PersonDepartureCardV2.vue?vue&type=script&lang=js"
export * from "./PersonDepartureCardV2.vue?vue&type=script&lang=js"
import style0 from "./PersonDepartureCardV2.vue?vue&type=style&index=0&id=6753c34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6753c34e",
  null
  
)

export default component.exports